import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './Table.module.scss';


interface IColumn {
  title: ReactNode;               
  key: string;                   
  render?: (value: any) => ReactNode; 
  width?: string;
}


interface IData {
  value: Record<string, any>;
  config?: {
    className?: string;
  };
}

interface PivotTableProps {
  columns: IColumn[];
  data: IData[];
  uniqueKey?: string;      
  className?: string;      
}

export const Table: FC<PivotTableProps> = ({
  columns,
  data,
  uniqueKey = 'id',
  className,
}) => {
  return (
    <div className={styles.tableContainer}>
      <table className={classNames(styles.pivotTable, className)}>
        <tbody>
          {columns.map((col) => (
            <tr key={col.key} className={styles.bodyRow}>
              <th 
                className={styles.leftHeaderCell}
                style={col.width ? { width: col.width, minWidth: col.width } : undefined}
              >
                {col.title}
              </th>

              {data.map((item, index) => {
                const cellKey = `${col.key}-${item.value[uniqueKey] ?? index}`;
                const rawValue = item.value[col.key];
                const cellValue = col.render?.(rawValue) ?? rawValue;

                return (
                  <td
                    key={cellKey}
                    className={classNames(
                      styles.bodyCell,
                      index % 2 === 0 ? styles.evenCol : styles.oddCol,
                      item.config?.className
                    )}
                    style={col.width ? { width: col.width, minWidth: col.width } : undefined}
                  >
                    {cellValue}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};